// What kind of proof a talent just picked, by file extension. "export" is a
// DJ-software track-history file; "screenshot" is a photo of the same; null
// means the upload screens should reject it.
export type UploadFileKind = "export" | "screenshot";

export function classifyUploadExtension(filename: string): UploadFileKind | null {
  const m = filename.toLowerCase().match(/\.([a-z0-9]+)$/);
  if (!m) return null;
  const ext = m[1];
  if (["csv", "txt", "xml", "m3u", "m3u8"].includes(ext)) return "export";
  if (["png", "jpg", "jpeg"].includes(ext)) return "screenshot";
  return null;
}
